import { Button, DialogTitle, DialogTrigger, makeStyles } from "@fluentui/react-components";
import { Dismiss24Regular } from "@fluentui/react-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiceD20 } from '@fortawesome/free-solid-svg-icons';

export default function SignUpTitle() {
	const styles = useStyles();

	return (
		<DialogTitle
			className={styles.title}
			action={
				<DialogTrigger action="close">
					<Button
						appearance="subtle"
						aria-label="close"
						icon={<Dismiss24Regular />}
					/>
				</DialogTrigger>
			}
		>
			<FontAwesomeIcon className={styles.icon} icon={faDiceD20} />
			<p className={styles.titleText}>Character Sheet</p>
		</DialogTitle>
	)
}

const useStyles = makeStyles({
	title: {
		display: "flex",
		columnGap: "10px"
	},
	titleText: {
		fontFamily: "'Press Start 2P', sans serif"
	},
	icon: {
		paddingTop: "4px"
	}
});